<form [formGroup]="form"
      class="address-form">

  <div class="address-form__line wide">
    <ifc-google-places-autocomplete-form-field
      [control]="form.get('line1')"
      fieldType="street"
      cssClass="wide"
      (placeSelected)="handleStreetAddressChange($event)">
    </ifc-google-places-autocomplete-form-field>
  </div>

  <div class="address-form__line">
    <mat-form-field appearance="outline">
      <mat-label>Unit/Suite/Apt #</mat-label>
      <input id="address-line2-form-field"
             matInput
             [formControl]="form?.controls?.line2"
             type="text"
             autocomplete="address-line2"
             [maxlength]="ValidationData.addressLine2MaxLength + 1" />
      <mat-error id="address-line2-max-length-error-msg"
                 *ngIf="form.get('line2').errors | hasControlError">
        Unit/Suite/Apt # is too long.
      </mat-error>
    </mat-form-field>

    <ifc-google-places-autocomplete-form-field
      [control]="form.get('city')"
      fieldType="city"
      (placeSelected)="handleCityAddressChange($event)">
      <mat-error id="city-incorrect-error-msg"
                 *ngIf="form.get('city').errors | hasControlError:['pattern']:ConditionOperator.Only">
        Incorrect city.
      </mat-error>
    </ifc-google-places-autocomplete-form-field>
  </div>

  <div class="address-form__line">
    <mat-form-field appearance="outline">
      <mat-label>State</mat-label>
      <mat-select id="state-form-field"
                  matInput
                  type="text"
                  [formControl]="form?.controls?.state"
                  autocomplete="address-level1">
        <mat-option *ngFor="let state of States"
                    [value]="state.value">{{
          state.label
        }}</mat-option>
      </mat-select>
      <mat-error id="state-required-error-msg"
                 *ngIf="form.get('state').errors | hasControlError:['required']">
        State is required.
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Zip code</mat-label>
      <input id="zip-code-form-field"
             matInput
             [formControl]="form?.controls?.zip"
             type="text"
             autocomplete="postal-code"
             [maxlength]="ValidationData.zipMaxLength" />
      <mat-error id="zip-required-error-msg"
                 *ngIf="form.get('zip').errors | hasControlError:['required']">
        Zip code is required.
      </mat-error>
      <mat-error id="zip-incorrect-error-msg"
                 *ngIf="form.get('zip').errors | hasControlError:['required']:ConditionOperator.Exclude">
        Incorrect zip code.
      </mat-error>
    </mat-form-field>
  </div>
</form>
